'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    //今天及今天之后 现在的时间减
    beforeToday: {
        disabledDate: function disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e7;
        }
    },
    //今天之后不包含今天
    beforeTodayNotToday: {
        disabledDate: function disabledDate(time) {
            return time.getTime() > Date.now();
        }
    },
    //今天及今天之前
    afterToday: {
        disabledDate: function disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
        }
    },
    // 今天之前包含今天
    afterTodayNotToday: {
        disabledDate: function disabledDate(time) {
            return time.getTime() < Date.now();
        }
    },
    //今天及今天之后 现在日期的23:59减
    beforeTodayStrict: {
        disabledDate: function disabledDate(time) {
            return time.getTime() > new Date(new Date(new Date().getTime()).setHours(23, 59, 59, 999)).getTime() - 8.64e7;
        }
    },
    pickerOptions: {
        shortcuts: [{
            text: '最近一个月',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 - 1).setHours(23, 59, 59, 999)).getTime();
                var start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 - 3600 * 1000 * 24 * 30).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近三个月',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 - 1).setHours(23, 59, 59, 999)).getTime();
                var start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 - 3600 * 1000 * 24 * 90).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近半年',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 - 1).setHours(23, 59, 59, 999)).getTime();
                var start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 - 3600 * 1000 * 24 * 180).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近一年',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 - 1).setHours(23, 59, 59, 999)).getTime();
                var start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 - 3600 * 1000 * 24 * 360).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '无固定期限',
            onClick: function onClick(picker) {
                var end = new Date(4102415999000).getTime();
                var start = new Date(new Date(new Date().getTime()).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        }]
    },
    // 往后选择日期
    // 多少天后就是乘以（多少天+1）
    pickerOptionsAfter: {
        shortcuts: [{
            text: '90天后',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 + 3600 * 1000 * 24 * 91).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', end);
            }
        }, {
            text: '180天后',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 + 3600 * 1000 * 24 * 181).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', end);
            }
        }, {
            text: '270天后',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 + 3600 * 1000 * 24 * 271).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', end);
            }
        }, {
            text: '360天后',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 + 3600 * 1000 * 24 * 361).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', end);
            }
        }]
    },
    //长期的日期使用
    singlePickerOptions: {
        disabledDate: function disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
        },

        shortcuts: [{
            text: '长期',
            onClick: function onClick(picker) {
                var end = new Date(4102415999000).getTime();
                picker.$emit('pick', end);
            }
        }]
    },
    // 自定义选择区间
    pickerOptionsFn: function pickerOptionsFn(interval) {
        // interval 时间区间  []
        // today 今天、yesterday 昨天、week 本周、lastWeek 上周、month本月、lastMonth上月、latelyMonth最近一个月、lastThreeMonths 最近三个月、halfYear 最近半年、latelyYear最近一年、year今年、lastyear去年、notFixed 无固定期限
        var pickerOptions = {};
        // 今天
        pickerOptions.today = {
            text: '今天',
            onClick: function onClick(picker) {
                var start = new Date();
                var end = new Date();
                picker.$emit('pick', [start, end]);
            }
        };
        pickerOptions.yesterday = {
            text: "昨天",
            onClick: function onClick(picker) {
                var date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24);
                picker.$emit("pick", [date, date]);
            }
        };
        pickerOptions.week = {
            text: "本周",
            onClick: function onClick(picker) {
                var start = new Date();
                var end = new Date();
                var nows = start.getDay() || 7; //注意周日算第一天，如果周日查询本周的话，天数是0，所有如果是0，默认设置为7
                start.setTime(start.getTime() - 3600 * 1000 * 24 * (nows - 1));
                picker.$emit('pick', [start, end]);
            }
        };
        pickerOptions.lastWeek = {
            text: "上周",
            onClick: function onClick(picker) {
                var dataValue = new Date();
                var year = dataValue.getFullYear();
                var month = dataValue.getMonth() + 1;
                var day = dataValue.getDate();
                var thisWeekStart; //本周周一的时间
                if (dataValue.getDay() == 0) {
                    //周天的情况；
                    thisWeekStart = new Date(year + "/" + month + "/" + day).getTime() - (dataValue.getDay() + 6) * 86400000;
                } else {
                    thisWeekStart = new Date(year + "/" + month + "/" + day).getTime() - (dataValue.getDay() - 1) * 86400000;
                }
                var prevWeekStart = thisWeekStart - 7 * 86400000; //上周周一的时间
                var prevWeekEnd = thisWeekStart - 1 * 86400000; //上周周日的时间
                var start = new Date(prevWeekStart); //开始时间
                var end = new Date(prevWeekEnd); //结束时间
                picker.$emit("pick", [start, end]);
            }
        };
        pickerOptions.month = {
            text: "本月",
            onClick: function onClick(picker) {
                var end = new Date();
                var start = new Date();
                start.setDate(1);
                picker.$emit("pick", [start, end]);
            }
        };
        pickerOptions.lastMonth = {
            text: "上月",
            onClick: function onClick(picker) {
                var start = new Date();
                var end = new Date(start);
                end.setMonth(start.getMonth());
                start.setMonth(start.getMonth() - 1);
                end.setDate(0);
                start.setDate(1);
                picker.$emit("pick", [start, end]);
            }
        };
        pickerOptions.latelyMonth = {
            text: '最近一个月',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 - 1).setHours(23, 59, 59, 999)).getTime();
                var start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 - 3600 * 1000 * 24 * 30).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        };
        pickerOptions.lastThreeMonths = {
            text: '最近三个月',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 - 1).setHours(23, 59, 59, 999)).getTime();
                var start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 - 3600 * 1000 * 24 * 90).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        };
        pickerOptions.halfYear = {
            text: '最近半年',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 - 1).setHours(23, 59, 59, 999)).getTime();
                var start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 - 3600 * 1000 * 24 * 180).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        };
        pickerOptions.latelyYear = {
            text: '最近一年',
            onClick: function onClick(picker) {
                var end = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 - 1).setHours(23, 59, 59, 999)).getTime();
                var start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 - 3600 * 1000 * 24 * 360).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        };
        pickerOptions.year = {
            text: "今年",
            onClick: function onClick(picker) {
                var end = new Date();
                var start = new Date().getFullYear();
                var startYear = new Date(start, 0, 1);
                picker.$emit("pick", [startYear, end]);
            }
        };
        pickerOptions.lastYear = {
            text: "去年",
            onClick: function onClick(picker) {
                var end = new Date().getFullYear() - 1;
                var start = new Date().getFullYear() - 1;
                var startYear = new Date(start, 0, 1);
                var endYear = new Date(end, 11, 31);
                picker.$emit("pick", [startYear, endYear]);
            }
        };
        pickerOptions.notFixed = {
            text: '无固定期限',
            onClick: function onClick(picker) {
                var end = new Date(4102415999000).getTime();
                var start = new Date(new Date(new Date().getTime()).setHours(0, 0, 0, 0)).getTime();
                picker.$emit('pick', [start, end]);
            }
        };

        var shortcuts = new Array();
        interval.map(function (item) {
            shortcuts.push(pickerOptions[item]);
        });
        return {
            shortcuts: shortcuts
        };
    },

    // 自定义快速选择
    pickerOptionsAfterFn: function pickerOptionsFn(interval) {
        var shortcuts = [];
        interval.map(function (item) {
            var shortcutObj = {
                text: item + '\u5929\u540E',
                onClick: function onClick(picker) {
                    var end = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 + 3600 * 1000 * 24 * (item * 1 + 1)).setHours(0, 0, 0, 0)).getTime();
                    picker.$emit('pick', end);
                }
            };
            shortcuts.push(shortcutObj);
        });
        return {
            shortcuts: shortcuts
        };
    }
};